import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const AmountTilePreset = ({ active, amount, estimate, onClick }) => (
    <button
        type="button"
        className={cx(
            'flex flex-col justify-center items-center relative w-full h-full bg-white text-center rounded',
            {
                'py-12 md:py-16': estimate == null,
                'py-8 md:py-12': estimate != null,
                'text-gray-70 shadow-lg': active,
                'text-gray-30 shadow': !active,
            }
        )}
        onClick={onClick}
    >
        <span className="block text-18 md:text-21 font-bold">{amount}</span>
        {estimate && (
            <span
                className={cx('block transition text-14 md:text-16 mt-2', {
                    'text-gray-40': active,
                })}
            >
                ({estimate})
            </span>
        )}
    </button>
);

AmountTilePreset.propTypes = {
    amount: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
    estimate: PropTypes.string,
};

AmountTilePreset.defaultProps = {
    active: false,
    estimate: null,
};

export default AmountTilePreset;
